import { useContext, useState } from 'react';

import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import { DetailedRoute } from '@/generated/model/detailedRoute';
import { ctxPopup } from '@/contexts/PopupContext';
import { ctxRoutes } from '@/contexts/RoutesCtx.tsx';
import { rethrowIfNotClientException } from '@/utilities/throwableUtils';
import DisplayNoResult from '../common/DisplayNoResult';
import { MinimalTarget } from '@/generated/model';
import { getTargetRoutes } from '@/generated/client/routes/routes';

function filterDuplicate(routes: DetailedRoute[] | undefined) {
  if (!routes) return routes;
  const routesSorted = routes.sort((a, b) => a.startPosition.timeMicros - b.startPosition.timeMicros);

  let previous: number = -1;
  const routesFiltered = routesSorted.filter((r) => {
    if (r.startPosition.timeMicros <= previous) return false;
    previous = r.startPosition.timeMicros;
    return true;
  });

  return routesFiltered;
}

export function RoutesDateSelect({
  selectedTarget,
  setRoutes,
  setSelectedDates,
}: {
  selectedTarget: MinimalTarget | undefined;
  setRoutes: (values: DetailedRoute[] | undefined) => void;
  setSelectedDates: (from: Date, to: Date) => void;
}) {
  const [result, setResult] = useState<boolean | undefined>(undefined);
  const ctxPopups = useContext(ctxPopup);
  const ctxRoute = useContext(ctxRoutes);

  async function setValuesWrapper(from: Date, to: Date) {
    if (!selectedTarget || !from || !to) {
      setResult(undefined);
      return;
    }

    ctxPopups?.showLoader('circular');
    try {
      setResult(undefined);
      const result = await getTargetRoutes(selectedTarget.id, {
        fromTime: from.getTime() * 1000,
        toTime: to.getTime() * 1000,
      });
      ctxRoute?.setSelectedDates({ from: from, to: to });
      const count = result.data.length;
      if (count === 0) {
        setResult(true);
        ctxRoute?.setIsBottomSheetOpen(false);
      } else {
        setResult(undefined);
        setRoutes(filterDuplicate(result.data));
        setSelectedDates(from, to);
      }
    } catch (error) {
      rethrowIfNotClientException(error);
    } finally {
      ctxPopups?.hideLoader();
    }
  }

  function chooseNewVehicle() {
    setResult(undefined);
    ctxRoute?.setSelectedTarget(undefined);
    ctxRoute?.setTab(0);
  }

  function chooseNewDate() {
    setResult(undefined);
    ctxRoute?.setSelectedDates(undefined);
  }

  return (
    <>
      {ctxRoute?.selectedDates && result ? (
        <DisplayNoResult chooseNewDate={chooseNewDate} chooseNewVehicle={chooseNewVehicle} />
      ) : (
        <StaticDateRangeSelect
          setSelectedDates={setValuesWrapper}
          // currentValue={{ from: ctxRoute?.selectedDates?.from ?? null, to: ctxRoute?.selectedDates?.to ?? null }}
        />
      )}
    </>
  );
}
